// eslint-disable-next-line import/prefer-default-export
export const VISIBILITY_FILTERS = {
  ALL: 'all',
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete',
};

export const MULTI_PART_FILE_SIZE = 500 * 1024 * 1024;
// export const MULTI_PART_FILE_SIZE = 0;

export const MULTI_PART_FILE_CHUNK_SIZE = 55 * 1024 * 1024;
// export const MULTI_PART_FILE_CHUNK_SIZE = 1024 * 1024;

export const DESIGN_PATH_CHARACTER_LIMIT_FOLDER = 140;
export const DESIGN_PATH_CHARACTER_LIMIT_FILE = 160;

// Folder-upload limits. Files are chunked into presign requests of DESIGN_UPLOAD_PRESIGN_CHUNK
// (the backend rejects requests over MAX_UPLOAD_PRESIGN_BATCH = 200); the folder count and
// depth mirror the backend's create-folders limits (MAX_DEFAULT_FOLDERS/_DEPTH).
export const DESIGN_FOLDER_UPLOAD_MAX_FILES = 1000;
export const DESIGN_FOLDER_UPLOAD_MAX_FOLDERS = 200;
export const DESIGN_FOLDER_UPLOAD_MAX_DEPTH = 10;
export const DESIGN_UPLOAD_PRESIGN_CHUNK = 100;
export const DESIGN_UPLOAD_CONCURRENCY = 3;

/** Folder icon fill, matching the yellow Windows Explorer uses for folders. */
export const FOLDER_ICON_COLOR = '#FFC107';

/**
 * Stands in for the project name at the root of a default folder structure, for the subscriber
 * admin dashboard, where the structure is not tied to one project yet.
 */
export const PROJECT_NAME_PLACEHOLDER = 'Project Name';

// Placeholder options for the Potential Change Order "Reason for Change" field.
// Multi-select; stored on the document as a string[] (reasonForChange).
export const REASON_FOR_CHANGE_OPTIONS = [
  'Owner Change',
  'Design Issue',
  'Unforeseen Condition',
  'Regulatory Requirement',
  'Construction Impact',
];
